import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { openFormLayoutModal } from '../actions/formLayoutModal';
export var Context = /*#__PURE__*/function () {
  function Context(store, emitter, applicationContext) {
    var _this = this;
    _classCallCheck(this, Context);
    _defineProperty(this, "store", void 0);
    _defineProperty(this, "emitter", void 0);
    _defineProperty(this, "applicationContext", void 0);
    _defineProperty(this, "on", function (event, handler) {
      _this.emitter.addListener(event, handler);
    });
    _defineProperty(this, "off", function (event, handler) {
      _this.emitter.removeListener(event, handler);
    });
    this.store = store;
    this.emitter = emitter;
    this.applicationContext = applicationContext;
  }
  _createClass(Context, [{
    key: "getStore",
    value: function getStore() {
      return this.store;
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.store.getState();
    }
  }, {
    key: "getApplicationContext",
    value: function getApplicationContext() {
      return this.applicationContext;
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.store.dispatch(openFormLayoutModal());
    }
  }]);
  return Context;
}();